import React, {useEffect, useState, useMemo} from 'react'
import Swal from 'sweetalert2';
import Icon from "@mdi/react";
import {mdiArrowDownCircleOutline, mdiClose} from "@mdi/js";
import Styles from "./AnnexesView.scss"
import UEPagination from "../utilities/UEPagination";


const linkstyle = {
    maxHeight: "500px",
    overflow: 'auto',

}

const sectionStyle = {
    "width": "100%",
    "fontSize": "0.9rem",
    "fontWeight": "700",
    "textAlign": "left",
    "marginBottom": "8px",
    "marginTop": "15px",
    "paddingBottom": "4px",
    "borderBottom": "1px solid #ccc",
    "textTransform": "capitalize",
}

const AnnexesView = (props)=>{

    const [refs, setRefs] = useState([])
    const [count, setCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(0);
    let pageSize = 6;

    useEffect(()=>{
    let swalRefContent = document.querySelector(".swal2-content");
        swalRefContent.setAttribute('class', "p-0");
    },[])

    useEffect(()=>{
        if(props.links){
            //console.log(props.links)
            let array = [];
            Object.keys(props.links).forEach((item,index)=>{
                props.links[item].data.map(item=>array.push(item))
            })
            //console.log("array",array);
            setRefs([..._.uniqBy(array, 'url')]);
            //setRefs([...array]);
            setCurrentPage(1);
        }
    }, [props.links])

    useEffect(()=>{

    }, [refs])

    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * pageSize;
        const lastPageIndex = firstPageIndex + pageSize;
        return  refs.length?refs.slice(firstPageIndex, lastPageIndex):null
    }, [currentPage]);

   /* const renderSection=(item, index)=>{
        console.log(item)
        return (
                    ( refs[item] )?
                        _.uniq(refs[item]).map((item2, index2)=>{
                            return renderLink(item2, index2)
                        })
                        :null
        )
    }*/

    const renderLink=(item, index)=>{
        //console.log("link",item)
       return(
           <tr key={index} >
               <td><span className={"text-capitalize font-weight-bold"}>{item.section.toUpperCase()}</span></td>
               <td>Réglement</td>
               <td><span>{item.title}</span></td>
               <td>
                   <a target={"_blank"} rel={"noopener noreferrer"}
                       href={item.url}>
                       <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <circle cx="9" cy="9" r="9" fill="#BDF4EE"/>
                           <path d="M11.8806 8.6985L9.5625 11.0171V5.0625C9.5625 4.752 9.3105 4.5 9 4.5C8.6895 4.5 8.4375 4.752 8.4375 5.0625V11.0171L6.11944 8.69906C5.8995 8.47912 5.54344 8.47912 5.32406 8.69906C5.10412 8.919 5.10412 9.27506 5.32406 9.49441L8.50612 12.6765C8.64112 12.8115 8.82562 12.8531 9.00059 12.8221C9.17497 12.8531 9.36003 12.8109 9.49503 12.6765L12.6771 9.49441C12.897 9.27447 12.897 8.91844 12.6771 8.69906C12.4566 8.47912 12.1005 8.47912 11.8806 8.6985Z" fill="#3FB9AA"/>
                       </svg>

                   </a>
               </td>
           </tr>
       )
    }


    return(
        <div className={"d-flex flex-column w-100"} style={{"fontSize":"0.7rem"}}>
            <div className={"w-100  d-flex flex-column flex-md-row justify-content-between align-items-end font-lg text-white ue-annexes-panel-header"} >
                <h3 className={"d-block mb-0 ue-annexes_panel-title"} >ANNEXES</h3>
                <div  style={{"fontSize":"0.80rem","paddingBottom":"15px"}}>Retrouvez ici tous vos règlements liés au dossier</div>
                <div className={"ue-annexe-panel-close-btn"} onClick={(e)=>Swal.close()}>
                    <Icon path={mdiClose} size={0.7} />
                </div>
            </div>
            <div className={"p-4"} >
                <table className="table ue-annexes-table">
                    <thead>
                    <tr style={{"backgroundColor":"unset"}}>
                        <th scope="col">Thématiques</th>
                        <th scope="col">Documents</th>
                        <th scope="col" className={"w-100"}>Description</th>
                        <th scope="col">Pdf</th>
                    </tr>
                    </thead>
                    <tbody>
                    {(currentTableData)?
                        currentTableData.map((item,index)=>{
                            return renderLink(item,index)
                        })
                        :<tr><td colSpan={4} >Pas de documents disponibles</td></tr>
                       }
                    </tbody>
                </table>
                    <UEPagination
                    className="ue-pagination-bar"
                    currentPage={currentPage}
                    totalCount={refs.length}
                    pageSize={pageSize}
                    onPageChange={page => setCurrentPage(page)}
                />
            <div>
            </div>
        </div>
        </div>
    )
};


export default AnnexesView
